class HeaderDrawer extends HTMLElement {
  constructor() {
    super();
     this.mainDetailsToggle = this.querySelectorAll('details');
     this.navSubMenu = this.querySelector('.header__submenu');
     this.activeMenuClass = 'navmenu-link-parent-active';
     this.addEventListener('keyup', this.onKeyUp.bind(this));
     //this.addEventListener('focusout', this.onFocusOut.bind(this));
     this.bindEvents();
  }
  onFocusOut(event) {
   setTimeout(() => {
      this.closeMenuDrawer(event);
   });
 }
 bindEvents() {
   this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
   /* Accessibility: Enter/Space on a focused top-level item toggles its
      flyout (the mouse-only hover behavior left keyboard users unable to
      open the mega menu at all, and click/Enter navigated away instead). */
   this.querySelectorAll('summary').forEach(summary => summary.addEventListener('keydown', this.onSummaryKeydown.bind(this)));
   /* Close the flyout when keyboard focus leaves the nav entirely. */
   this.addEventListener('focusout', () => {
     setTimeout(() => {
       if (!this.contains(document.activeElement)) this.closeAllMenus();
     }, 0);
   });
   this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
   this.mainDetailsToggle.forEach(summary => {
     summary.addEventListener('mouseleave', this.closeMenu.bind(this))
     summary.addEventListener('mouseenter', this.open.bind(this))
   });

   this.querySelectorAll('.header__submenu .navmenu-link-parent').forEach(submenu => {
     //submenu.addEventListener('click', this.toggleSubmenu.bind(this))
    });
    this.querySelectorAll('.header__submenu:not(.navmenu-meganav) .navmenu-item-parent').forEach(submenu => {
        const $target = submenu.querySelector('.navmenu-link-parent');

        submenu.addEventListener('mouseleave', this.closeSubmenu.bind(submenu,$target))
        submenu.addEventListener('mouseenter', this.openSubmenu.bind(submenu,$target))

     });
    // this.querySelectorAll('.navmenu-depth-1 > .navmenu-item-parent:not(.navmenu-meganav__item-parent)').forEach(menu => {
    //   //  menu.addEventListener('mouseenter', this.openMenu.bind(this))
    //     menu.addEventListener('mouseleave', this.closeMenu.bind(this))
    //     //submenu.addEventListener('mouseenter', this.openSubmenu.bind(submenu,$target))
    //  });

 }
 onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    /* Accessibility: Escape closes the open flyout and returns focus
       to its top-level item. */
    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    if (summaryElement) {
      summaryElement.setAttribute('aria-expanded', 'false');
      summaryElement.focus();
    }
  }

  /* Keyboard toggle for the top-level flyouts. preventDefault() stops the
     browser's synthetic click, so onSummaryClick (which navigates) never
     fires for keyboard activation; mouse clicks are unaffected. */
  onSummaryKeydown(event) {
    if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
    event.preventDefault();

    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (isOpen) {
      detailsElement.removeAttribute('open');
      summaryElement.setAttribute('aria-expanded', 'false');
    } else {
      this.closeAllMenus();
      detailsElement.setAttribute('open', true);
      summaryElement.setAttribute('aria-expanded', 'true');
    }
  }

  closeAllMenus() {
    this.querySelectorAll('details[open]').forEach((details) => {
      details.removeAttribute('open');
      const summaryElement = details.querySelector('summary');
      if (summaryElement) summaryElement.setAttribute('aria-expanded', 'false');
    });
  }
  onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const isOpen = detailsElement.hasAttribute('open');
      const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
      
      console.log(event.target.dataset.href);
      function addTrapFocus() {
        trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
        summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
      }

      window.location.href = event.target.dataset.href;

      // if (detailsElement === this.mainDetailsToggle) {
      //   if(isOpen) event.preventDefault();
      //   isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
      // } else {
      //   setTimeout(() => {
      //     detailsElement.classList.add('menu-opening');
      //     summaryElement.setAttribute('aria-expanded', true);
      //     !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      //   }, 100);
      // }
    }
    openMenuDrawer(summaryElement) {
       setTimeout(() => {
         //this.mainDetailsToggle.classList.add('menu-opening');
       });
       summaryElement.setAttribute('aria-expanded', true);
       //trapFocus(this.mainDetailsToggle, summaryElement);
       document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
    openMenu(event) {
      const detailsElement = event.target.closest('details');
      const isOpen = detailsElement.hasAttribute('open');
      if(!isOpen) detailsElement.setAttribute('open', true);
      function addTrapFocus() {
        trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
        summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
      }
    }
    open(event) {
      const detailsElement = event.target;
      const isOpen = detailsElement.hasAttribute('open');
      if(!isOpen) detailsElement.setAttribute('open', true);
      detailsElement.querySelector('summary')?.setAttribute('aria-expanded', 'true');
      function addTrapFocus() {
        trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
        summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
      }
    }
    closeMenu(event) {
      const detailsElement = event.target;
      const isOpen = detailsElement.hasAttribute('open');
      if(isOpen) detailsElement.removeAttribute('open');
      detailsElement.querySelector('summary')?.setAttribute('aria-expanded', 'false');
   }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;
    //console.log(this.mainDetailsToggle)
    // this.mainDetailsToggle.classList.remove('menu-opening');
    // this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
    //   details.removeAttribute('open');
    //   details.classList.remove('menu-opening');
    // });
    removeTrapFocus(elementToFocus);
    //this.closeAnimation(this.mainDetailsToggle);
  //  this.header.classList.remove('menu-open');
    this.navSubMenu.setAttribute('data-animation-state', 'closed');
  }
  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }
  toggleSubmenu(event){
    event.preventDefault();
    const $target = event.currentTarget;
    const $menu = $target.nextElementSibling;;
    if($menu.getAttribute('data-animation-state') == 'open'){
      this.closeSubmenu($target);
    }else{
      this.openSubmenu($target);
    }
  }
  openSubmenu($target) {
   const $menu = $target.nextElementSibling;;
   $menu.setAttribute('data-animation-state', 'open');
 }
  closeSubmenu($target) {
    const $menu = $target.nextElementSibling;;
    $menu.setAttribute('data-animation-state', 'closed');
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('header-drawer', HeaderDrawer);
